import fetchLogger from "./fetchLogger";

/** PATCH /api/v1/issues/:id — update status and/or resolutionNote */
export default async function updateIssue(id, body) {
  const result = { return: 0, msg: "Failed updating issue", data: null };

  const res = await fetchLogger({
    method: "PATCH",
    url: `/api/v1/issues/${id}`,
    data: body,
  });

  if (res.ok) {
    result.return = 1;
    result.msg = "Issue updated";
    result.data = res.data?.data || null;
  } else {
    const message = res.data?.message;
    result.msg = Array.isArray(message) ? message.join(", ") : message || result.msg;
  }

  return result;
}
